import React, { type FC, memo } from "react";

import { useDetailedGrade, useGetCompareGrades } from "../../compareHooks";
import PackRow from "./PackRow";

const PacksMultiple: FC = () => {
    const grades = useGetCompareGrades();
    const detailedGrade1 = useDetailedGrade(grades[0]);
    const detailedGrade2 = useDetailedGrade(grades[1]);

    if (!detailedGrade1 || !detailedGrade2) {
        return null;
    }

    const numRows = Math.max(detailedGrade1.packs.length, detailedGrade2.packs.length);

    return (
        <>
            {Array.from(Array(numRows)).map((_, index) => (
                // Index is unique here
                // eslint-disable-next-line react/no-array-index-key
                <PackRow key={index} packs={[detailedGrade1.packs[index], detailedGrade2.packs[index]]} />
            ))}
        </>
    );
};

export default memo(PacksMultiple);
